import { EmptyStateProps } from './EmptyState.types';

import { EmptyBox } from 'phosphor-icons';
import { c } from '../../../utils/tailwind-merge';
import { WriteReviewModalPropsMicrocopy } from '../../organisms/WriteReviewModal';

export const emptyWriteReview: WriteReviewModalPropsMicrocopy = {
  title: '',
  version: '',
  ownedDate: '',
  rateExperience: '',
  titleReview: '',
  titleReviewPlaceholder: '',
  writeReview: '',
  writeReviewPlaceholder: '',
  tips: {
    title: '',
    doTip: {
      title: '',
      content: '',
    },
    dontTip: {
      title: '',
      content: '',
    },
    cta: '',
    expand: '',
  },
  cancel: '',
  submit: '',
  close: '',
  remaining: '',
  ratingValidationMessage: '',
  reviewValidationMessage: '',
  remainingTitle: '',
  titleValidationMessage: '',
};

export const EmptyState = ({
  microcopy,
  onClick,
  modalTrigger,
  className = '',
  titleClassName = '',
  descriptionClassName = '',
  iconSizeMobile = 148,
}: EmptyStateProps) => {
  return (
    <section
      data-test="empty-state"
      aria-label={microcopy.title}
      className={c(
        'flex flex-col items-center justify-center gap-10 p-10',
        className
      )}
    >
      <div className="flex flex-col items-center justify-center gap-4">
        <div className="p-5">
          <EmptyBox
            size={iconSizeMobile}
            className="block md:hidden"
            aria-hidden="true"
          />
          <EmptyBox size={176} className="hidden md:block" aria-hidden="true" />
        </div>
        <h2
          className={c(
            'text-black/87 text-center text-md font-semibold leading-6 tracking-[-.252px]',
            titleClassName
          )}
        >
          {microcopy.title}
        </h2>
        <p
          className={c(
            'body-tiny text-center font-normal text-black/85',
            descriptionClassName
          )}
        >
          {microcopy.description}
        </p>
      </div>
      {onClick && microcopy.cta && modalTrigger}
    </section>
  );
};
